import { Badge, BadgeProps, forwardRef } from '@chakra-ui/react';
import { useEffect } from 'react';

import { useCurrentUser } from '../../../context/currentUserContext';

export const UnreadNotificationsCounter = forwardRef<BadgeProps, 'div'>((props, ref) => {
    const { unreadNotificationsCounter, updateUnreadNotificationsCounter } = useCurrentUser();

    useEffect(() => {
        updateUnreadNotificationsCounter();
    }, [updateUnreadNotificationsCounter]);

    return (
        <Badge
            ref={ref}
            borderRadius={21}
            bgColor="brand"
            color="white"
            px={2}
            py={0.5}
            minW={15}
            display="flex"
            justifyContent="center"
            alignItems="center"
            {...props}
        >
            {unreadNotificationsCounter}
        </Badge>
    );
});
